import {RESET_STRONG_TX} from "../types";


const resetStrongTx= () => async (dispatch) => {
  dispatch({type: RESET_STRONG_TX, payload: {auth: {txAuthenticated: false}}});
};
export default resetStrongTx;